 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALFTITLE from '@/components/halftitle'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import CONTENT from '@/components/content'
 import FOREWORD from '@/components/foreword'
 import ACKNOWLEDGEMENT from '@/components/acknowledgement'
 import INTRODUCTION from '@/components/introduction'
 import CHAPTER1 from '@/components/chapter1'
 import CHAPTER2 from '@/components/chapter2'
 import CHAPTER3 from '@/components/chapter3'
 import CHAPTER4 from '@/components/chapter4'
 import CHAPTER5 from '@/components/chapter5'
 import CHAPTER6 from '@/components/chapter6'
 import CHAPTER7 from '@/components/chapter7'
 import CHAPTER8 from '@/components/chapter8'
 import WRAPPING from '@/components/wrapping'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content",
 			"name" : "content",
 			"component" : CONTENT
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/acknowledgement",
 			"name" : "acknowledgement",
 			"component" : ACKNOWLEDGEMENT
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js